import { URLParam } from "@/helpers/interfaces/URLParam.ts";

export const detectReservationOfferParam = (): boolean =>
  new URLSearchParams(window.location.search).has(URLParam.ReservationOffer);
